import React from "react";

const REA_DEFAULT = "/logos/rea_trim.png";
const PARTNERS_DEFAULT = "/logos/dual_brand.png";

export const LogoRea = ({ src, className = "", size = "h-10" }) => (
  <img
    src={src || REA_DEFAULT}
    alt="Rea Company Srl"
    className={`${size} w-auto object-contain ${className}`}
    data-testid="logo-rea"
  />
);

export const LogoPartners = ({ src, className = "", size = "h-8" }) => (
  <img
    src={src || PARTNERS_DEFAULT}
    alt="Fastweb + Vodafone"
    className={`${size} w-auto object-contain ${className}`}
    data-testid="logo-partners"
  />
);

// Fastweb + Vodafone first, then Rea Company — bottom-aligned.
export const LogoLockup = ({ reaSrc, partnersSrc, className = "", partnersSize = "h-8", reaSize = "h-11" }) => (
  <div className={`flex items-center gap-4 ${className}`} data-testid="logo-lockup">
    <LogoPartners src={partnersSrc} size={partnersSize} />
    <span className="h-8 w-px bg-white/15" />
    <LogoRea src={reaSrc} size={reaSize} />
  </div>
);
